import React                   from 'react';
import PropTypes               from 'prop-types';
import withNinetyDaysRating    from '../HigherOrderComponents/ActorRating/withNinetyDaysRating';
import CustomerSatisfaction    from './CustomerSatisfaction';
import ActorChatRatingPropType from './ActorChatRatingPropType';

const ActorProfileHeaderRating = props => <CustomerSatisfaction {...props} />;

ActorProfileHeaderRating.propTypes = {
	actorId: PropTypes.number.isRequired,
	rating:  ActorChatRatingPropType,
};

export default withNinetyDaysRating(ActorProfileHeaderRating);
